<template>
  <div class="layout-filtro">
    <ValidationObserver v-slot="{ invalid }" ref="observer">
      <div class="corpo">
        <div class="titulo-filtro negrito">
          {{ titulo }}
        </div>
        <div class="segunda-cor-fonte subtitulo-filtro">
          Selecione os filtros para parametrização do <br />
          relatório desejado.
        </div>
        <slot />
        <div class="botao-continuar">
          <slot :invalid="invalid" name="botao" />
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";

export default {
  components: {
    ValidationObserver
  },
  props: {
    titulo: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.layout-filtro {
  padding: 40px 0;
  display: flex;
  flex-flow: wrap column;
  align-content: center;
  .corpo {
    min-height: 370px;
    display: flex;
    flex-flow: wrap column;

    .subtitulo-filtro {
      line-height: 21px;
      padding-bottom: 48px;
      text-align: center;
    }

    .titulo-filtro {
      font-size: 20px;
      padding-bottom: 16px;
      text-align: center;
    }
    .botao-continuar {
      margin-top: auto;
    }
  }
}
</style>
